// extracted by mini-css-extract-plugin
export default {"action":"style_action__7TBgA"};